<template>
    <v-form-field v-bind="$props">
        <template v-slot:append>
            <slot name="append"></slot>
        </template>
        <template v-slot:label-prepend>
            <slot name="label-prepend"></slot>
        </template>
        <template v-slot:label-append>
            <slot name="label-append"></slot>
        </template>
        <template v-slot:label>
            <slot name="label"></slot>
        </template>
        <template v-slot:content>
            <slot name="content">
                <v-menu
                        v-model="showDatePicker"
                        close-on-content-click
                        :nudge-left="50"
                        :nudge-bottom="5"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-if="!readonly" :autofocus="autofocus" autocomplete="off"
                                      class="form-input__border mr-2" solo
                                      flat
                                      style="min-width: 150px;max-width: 150px;"
                                      placeholder="选择日期"
                                      :disabled="disable"
                                      hide-details single-line dense v-model="dateValue"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on">
                            <template v-slot:prepend-inner>
                                <v-icon small>mdi-clock-outline</v-icon>
                            </template>
                            <template v-slot:append-outer>
                                <v-btn icon x-small>
                                    <v-icon x-small @click="dateValue='';timeValue=''">mdi-close-circle</v-icon>
                                </v-btn>
                            </template>
                        </v-text-field>
                        <span class="readonly-text" v-else>{{text}}</span>
                    </template>
                    <v-date-picker
                            v-model="dateValue"
                            @input="showDatePicker = false"
                    ></v-date-picker>
                </v-menu>

                <v-menu
                        v-model="showTimePicker"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-if="!readonly" :autofocus="autofocus" autocomplete="off"
                                      class="form-input__border" solo
                                      flat
                                      placeholder="选择时间"
                                      :disabled="disable||!dateValue"
                                      hide-details single-line dense v-model="timeValue"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on">
                            <template v-slot:prepend-inner>
                                <v-icon small>mdi-clock-outline</v-icon>
                            </template>
                            <template v-slot:append-outer>
                                <v-btn icon x-small @click="timeValue='00:00:00'">
                                    <v-icon x-small>mdi-close-circle</v-icon>
                                </v-btn>
                            </template>
                        </v-text-field>
                        <span class="readonly-text" v-else>{{text}}</span>
                    </template>
                    <v-time-picker
                            v-model="timeValue"
                            use-seconds
                            @input="showTimePicker = false"
                            format="24hr"
                    ></v-time-picker>
                </v-menu>
            </slot>
        </template>
    </v-form-field>
</template>
<script>
    export default {
        name: "FormDateTimeSelector.vue",
        props: {
            small: {
                type: Boolean,
                default: false
            },
            xSmall: {
                type: Boolean,
                default: false
            },
            xxSmall: {
                type: Boolean,
                default: false
            },
            middle: {
                type: Boolean,
                default: false
            },
            large: {
                type: Boolean,
                default: false
            },
            xLarge: {
                type: Boolean,
                default: false
            },
            xxLarge: {
                type: Boolean,
                default: false
            },
            label: {
                type: String
            },
            disable: {
                type: Boolean,
                default: false,
            },
            readonly: {
                type: Boolean,
                default: false
            },
            text: {},
            placeholder: {type: String},
            autofocus: {
                type: Boolean,
                default: false
            },
            labelWidth: {
                type: Number
            },
            fieldWidth: {
                type: Number,
                default: 300
            },
            hideLabel: {
                type: Boolean,
                default: false
            },
            removeLabel: {
                type: Boolean,
                default: false
            },
            items: String,
            dataItems: {
                type: Array
            },
            value: null,
            dataApi: String,
            itemText: {
                type: String,
                default: 'text'
            },
            itemValue: {
                type: String,
                default: 'value'
            },
            dataQueryParam: {}
        },
        data() {
            return {
                showDatePicker: false,
                showTimePicker: false,
                dateValue: null,
                timeValue: null
            }
        },
        watch: {
            value(val) {
                this.assignValue(val);
            },
            dateValue(val) {
                if (val && val.length > 0) {
                    this.$emit('input', val + " " + (this.timeValue ? this.timeValue : '00:00:00'));
                } else {
                    this.$emit('input', '');
                }
            },
            timeValue(val) {
                this.$emit('input', this.dateValue + " " + val);
            }
        },
        created() {
            if (this.value) {
                this.assignValue(this.value);
            }
            if (!this.dateValue && this.text) {
                this.assignValue(this.text);
            }
        },
        methods: {
            assignValue(str) {
                if (str) {
                    let ss = str.split(" ");
                    this.dateValue = ss[0];
                    this.timeValue = ss.length > 1 ? ss[1] : '';
                }
            }
        }
    }
</script>